// Permission format
// NAMESPACE-ACTION-[PERMISSION]

// -- NAMESPACE --
// cred -> credential
// shop -> shops
// acc -> accounts
// est -> establishments
// sup -> support

// -- ACTION --
// list | create | edit

// -- PERMISSION --
// string

export const protectedActions = {
  acc: {
    migrate: {
      'card-admin:admin': true
    }
  },
  cred: {
    edit: {
      acc: {
        'card-admin:admin': true
      }
    }
  },
  est: {
    edit: {
      acc: {
        'card-admin:admin': true
      },
      cred: {
        'card-admin:admin': true
      }
    }
  },
  sup: {
    reparse: {
      'card-admin:admin': true
    },
    refocus: {
      'card-admin:admin': true
    }
  }
};
